// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.field .help[data-v-19af6a2d] {\n  display: none;\n}\n.field--error .help[data-v-19af6a2d] {\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
